export const taiwanIdNumberFormatStrategy = (value: string) => {
  return /^[A-Z][0-9]{9}$/.test(value);
};
